import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { CurrencyModel } from '@root/entities/currency'
import { CopyButton, Truncate } from '@root/shared/ui-kit'

type Props = {
  currency: CurrencyModel
}

export const CurrencyAddressCell: React.FC<Props> = ({ currency }) => {
  const { t } = useTranslation()

  if (CurrencyModel.isNative(currency)) {
    return <Root></Root>
  }

  return (
    <Root>
      <Address>
        <Truncate start={8} end={7}>
          {currency.address}
        </Truncate>
      </Address>
      <Copy
        snackbarText={t('currency.token_address_copied_message', {
          ticker: currency.ticker,
        })}
        size={16}
        value={currency.address}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 3px;
  align-items: center;
`

const Address = styled.div`
  color: var(--text-9);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const Copy = styled(CopyButton)`
  color: var(--text-9);
`
